export default [
  {
    name: 'Apple',
    models: [
      'iPhone 13, 13 Mini, 13 Pro, 13 Pro Max',
      'iPhone 12, 12 Mini, 12 Pro, 12 Pro Max',
      'iPhone 11, 11 Pro, 11 Pro Max',
      'iPhone XS, XS Max, XR',
      'iPhone SE (2020, 2022)',
      'iPad Pro de 11 polegadas (1ª, 2ª e 3ª geração)',
      'iPad Pro de 12,9 polegadas (3ª, 4ª e 5ª geração)',
      'iPad (7ª, 8ª e 9ª geração)',
      'iPad Mini (5ª e 6ª geração)',
      'Apple watch séries 3, 4, 5 e 6',
      'Apple watch SE',
      'iPad Pro de 12,9 polegadas (3ª, 4ª e 5ª geração)'
    ],
    disclaimer: 'Estes dispositivos não são compatíveis: iPhones da China continental e dispositivos iPhone de Hong Kong e Macau (exceto iPhone 13 mini, iPhone 12 mini, iPhone SE 2020 e iPhone XS).'
  },
  {
    name: 'Samsung',
    models: [
      'Galaxy S22, S22+ 5G, S22 Ultra 5G',
      'Galaxy S21, S21+ 5G, S21 Ultra 5G',
      'Galaxy S20, S20+, S20 Ultra',
      'Galaxy Z Flip, Flip 3',
      'Galaxy Note 20, 20+, 20 Ultra',
      'Galaxy Fold, Fold 2, Fold 3',
      'Galaxy Watch'
    ],
    disclaimer: 'Estes dispositivos não são compatíveis: Galaxy S20 FE, Galaxy S20/S21 (versões dos EUA), Galaxy Z Flip 5G (versões dos EUA), Galaxy Note 20 Ultra (versões dos EUA e Hong Kong), Galaxy Fold 2 (versões dos EUA e Hong Kong)'
  },
  {
    name: 'Motorola',
    models: [
      'Motorola Razr 2019',
      'Motorola Razr 40 / 40 Ultra',
      'Edge 40'
    ]
  },
  {
    name: 'Google Pixel',
    models: [
      'Google Pixel 6, 6a, 6 Pro',
      'Google Pixel 5',
      'Google Pixel 3, 3 XL',
      'Google Pixel 3, 3a XL',
      'Google Pixel 4, 4a, 4 XL'
    ],
    disclaimer: 'Estes dispositivos não são compatíveis: dispositivos Google Pixel 3 da Austrália, Japão e Taiwan, Google Pixel 3a do Sudeste Asiático.'
  },
  {
    name: 'Outros',
    models: [
      'Huawei P40, P40 Pro',
      'Huawei Mate 40 pro',
      'Oppo Find X5, X5 Pro, X3 Pro',
      'Oppo Reno 5A, Reno 6 Pro 5G',
      'Sony Xperia 10 IV',
      'Sony Xperia 10 III LiteReno 5A, Reno 6 Pro 5G',
      'Motorola Razr (2019), Razr 5G',
      'Microsoft Surface Duo',
      'Nuu Mobile X5',
      'Honor Magic 4 Pro',
      'Fairphone 4'
    ]
  }
]
